import React from "react";

import { Alert } from "@performyard/py-components";

import Spacer from "../../../../../components/Spacer";

import { getFieldInput } from "../../../utils";

type FieldErrorFallbackProps = {
	field: any;
	onUpdate: (value: any) => void;
};

const FieldErrorFallback = ({ field, onUpdate }: FieldErrorFallbackProps) => {
	return (
		<div>
			{getFieldInput(field, "", (value) => onUpdate(value), false, false, field.name)}
			<Spacer height={1} />
			<Alert
				type="error"
				message="This field contains data in an incorrect format and cannot be displayed. Please update this field or contact your administrator."
			/>
		</div>
	);
};

export default FieldErrorFallback;
